<template>
    <div class="image-licence">
        <el-tooltip :content="licence">
            <div
                class="overflow-hidden"
                style="text-overflow: ellipsis; font-size: xx-small">
                <span style="white-space: nowrap">{{ licence }}</span>
            </div>
        </el-tooltip>
    </div>
</template>

<script>
export default {
    name: "ImageLicence",
    props: {
        licence: {
            type: String,
            required: true
        }
    }
}
</script>

<style lang="scss" scoped>
.image-licence {
    position: absolute;
    bottom: 0;
    width: 100%;
    background: $gray-900;
    color: $white;
    padding: .25rem;
    transition: opacity .25s;
    opacity: .25;
}

.image-licence:hover {
    opacity: .75;
}
</style>